import { Injectable } from "@angular/core";
import { gql, Apollo, Query } from "apollo-angular";

// Escrita à mão: o codegen aponta para um host fora do ar.
// Só diz se o usuário pode adicionar/remover anexos do Kaizen; a lista de
// arquivos continua vindo do REST `GET /idea-kaizen-file/:id`.
export type GetIdeaKaizenCanManageFilesQuery = {
  getIdeaKaizen: {
    id: string;
    canManageFiles: boolean;
  };
};

export type GetIdeaKaizenCanManageFilesQueryVariables = {
  id: string;
};

export const GetIdeaKaizenCanManageFilesDocument = gql`
  query GetIdeaKaizenCanManageFiles($id: String!) {
    getIdeaKaizen(id: $id) {
      id
      canManageFiles
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class GetIdeaKaizenCanManageFilesGQL extends Query<
  GetIdeaKaizenCanManageFilesQuery,
  GetIdeaKaizenCanManageFilesQueryVariables
> {
  document = GetIdeaKaizenCanManageFilesDocument;

  constructor(apollo: Apollo) {
    super(apollo);
  }
}
